export const GLOBAL_LABELS = 'global';

// global plccForm
export const lblPLCCFormCopyToClipboard = 'lbl_PLCCForm_copyToClipboard';
export const lblPLCCFormContinueShopping = 'lbl_PLCCForm_continueShopping';
export const lblPLCCCouponCopySuccess = 'lbl_PLCC_CouponCopy_Success';
export const lblPLCCCouponCopyFail = 'lbl_PLCC_CouponCopy_Fail';

export const lblPLCCExistFuturePurchases = 'lbl_PLCCExist_future_purchases';
export const lblPLCCExistClickHere = 'lbl_PLCCExist_click_here';
export const lblPLCCExistAddToAccount = 'lbl_PLCCExist_add_to_account';
export const lblPLCCFormCtcButton = 'lbl_PLCCForm_ctcButton';

export const lblPLCCFormContactInfoHeader = 'lbl_PLCCForm_contactInfoHeader';

export const lblPLCCFormMiddleNameInitial = 'lbl_PLCCForm_middleNameInitial';
export const lblPLCCFormEmail = 'lbl_PLCCForm_email';
export const lblPLCCFormAddressLine1 = 'lbl_PLCCForm_addressLine1';
export const lblPLCCFormAddressLine2 = 'lbl_PLCCForm_addressLine2';
export const lblPLCCFormCity = 'lbl_PLCCForm_city';
export const lblPLCCFormMobilePhoneNumber = 'lbl_PLCCForm_mobilePhoneNumber';
export const lblPLCCFormAlternatePhone = 'lbl_PLCCForm_alternatePhone';
export const lblPLCCFormMinPhone = 'lbl_PLCCForm_minPhone';
export const lblPLCCFormDob = 'lbl_PLCCForm_dob';

export const lblPLCCFormPersonalInfo = 'lbl_PLCCForm_personalInfo';
export const lblPLCCMonth = 'lbl_PLCC_month';
export const lblPLCCFormMonth = 'lbl_PLCCForm_month';
export const lblPLCCDay = 'lbl_PLCC_day';
export const lblPLCCFormDay = 'lbl_PLCCForm_day';
export const lblPLCCYear = 'lbl_PLCC_year';
export const lblPLCCFormYear = 'lbl_PLCCForm_year';

export const lblPLCCTimeoutModalPreacceptance = 'lbl_PLCCTimeoutModal_preacceptance';
export const lblPLCCTimeoutModalApplicationClosure = 'lbl_PLCCTimeoutModal_applicationClosure';
export const lblPLCCTimeoutModalClosureSubHeader = 'lbl_PLCCTimeoutModal_closureSubHeader';
export const lblPLCCTimeoutModalRestartAcceptance = 'lbl_PLCCTimeoutModal_restartAcceptance';
export const lblPLCCTimeoutModalRestartApplication = 'lbl_PLCCTimeoutModal_restartApplication';
export const lblPLCCTimeoutModalReturnCheckout = 'lbl_PLCCTimeoutModal_returnCheckout';

export const lblPLCCTimeoutModalStillThere = 'lbl_PLCCTimeoutModal_stillThere';
export const lblPLCCTimeoutModalContinueApplication = 'lbl_PLCCTimeoutModal_continueApplication';
export const lblPLCCTimeoutModalInterimText = 'lbl_PLCCTimeoutModal_interimText';

// global accountDrawer
export const lblAccountDrawerMyPlaceRewardsCCBenefitsHeading =
  'lbl_accountDrawer_myPlaceRewardsCC_benefits_heading';

const ApplyCardPageLabels = {
  global: {
    plccForm: {
      [lblPLCCFormCopyToClipboard]: 'Copy to Clipboard',
      [lblPLCCFormContinueShopping]: 'CONTINUE SHOPPING',
      [lblPLCCCouponCopySuccess]: 'Coupon code has been copied successfully.',
      [lblPLCCCouponCopyFail]: 'An error occured while copying the coupon code.',

      [lblPLCCExistFuturePurchases]: 'For future purchases, ',
      [lblPLCCExistClickHere]: 'Click Here',
      [lblPLCCExistAddToAccount]: 'to add your MY PLACE REWARDS CREDIT CARD to your account.',
      [lblPLCCFormCtcButton]: 'CONTINUE TO CHECKOUT',

      [lblPLCCFormContactInfoHeader]: 'CONTACT INFORMATION',

      [lblPLCCFormMiddleNameInitial]: 'M.I.',
      [lblPLCCFormEmail]: 'Email',
      [lblPLCCFormAddressLine1]: 'Address Line 1',
      [lblPLCCFormAddressLine2]: 'Address Line 2 (Optional)',
      [lblPLCCFormCity]: 'City',
      [lblPLCCFormMobilePhoneNumber]: 'Mobile Phone Number*',
      [lblPLCCFormAlternatePhone]: 'Alternate Phone Number*',
      [lblPLCCFormMinPhone]: 'At least one phone number is required',
      [lblPLCCFormDob]: 'Date of Birth',

      [lblPLCCFormPersonalInfo]: 'PERSONAL INFORMATION',
      [lblPLCCMonth]: 'Month',
      [lblPLCCFormMonth]: 'Mm',
      [lblPLCCDay]: 'Day',
      [lblPLCCFormDay]: 'Dd',
      [lblPLCCYear]: 'Year',
      [lblPLCCFormYear]: 'Yyyy',

      [lblPLCCTimeoutModalPreacceptance]: "We've closed your pre-screen acceptance.",
      [lblPLCCTimeoutModalApplicationClosure]: "We've closed your application.",
      [lblPLCCTimeoutModalClosureSubHeader]: 'To protect your privacy, we have closed this session',
      [lblPLCCTimeoutModalRestartAcceptance]: 'Restart Acceptance',
      [lblPLCCTimeoutModalRestartApplication]: 'Restart Application',
      [lblPLCCTimeoutModalReturnCheckout]: 'RETURN TO CHECKOUT',

      [lblPLCCTimeoutModalStillThere]: 'Still there',
      [lblPLCCTimeoutModalContinueApplication]: 'Continue Application',
      [lblPLCCTimeoutModalInterimText]:
        "To protect your privacy, we will close this page in XX seconds if you don't choose to continue.",
    },
    accountDrawer: {
      [lblAccountDrawerMyPlaceRewardsCCBenefitsHeading]: 'MY PLACE REWARDS CREDIT CARD BENEFITS',
    },
  },
};
export default ApplyCardPageLabels;
